module.exports = __webpack_public_path__ + "img/4.01.thmb.5d78b2ae.jpg";